<template>
  <div v-if="!summary" class="text-muted">
    Нет данных о плане
  </div>
  <b-row v-else>
    <b-col v-for="card in cards" :key="card.title" cols="6" md="3" :class="compact ? 'mb-50' : 'mb-1'">
      <b-card class="mb-0 h-100" :body-class="compact ? 'p-1' : null">
        <div class="d-flex align-items-center">
          <b-avatar :size="compact ? '36' : '48'" :variant="`light-${card.variant}`">
            <feather-icon :icon="card.icon" :size="compact ? '16' : '22'" />
          </b-avatar>
          <div class="ml-1">
            <small class="text-muted d-block">{{ card.title }}</small>
            <component :is="compact ? 'h5' : 'h4'" class="mb-0">{{ card.value }}</component>
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BCard, BAvatar } from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import { formatConversion } from '@/views/game/planFact'

export default {
  components: { BRow, BCol, BCard, BAvatar },
  props: {
    summary: { type: Object, default: null },
    compact: { type: Boolean, default: false },
  },
  setup(props) {
    const cards = computed(() => {
      const s = props.summary || {}
      return [
        {
          title: 'План',
          value: s.planned_total != null ? s.planned_total : '—',
          icon: 'CalendarIcon',
          variant: 'primary',
        },
        {
          title: 'Проведено',
          value: s.held != null ? s.held : '—',
          icon: 'CheckCircleIcon',
          variant: 'success',
        },
        {
          title: 'Не состоялось',
          value: s.no_show != null ? s.no_show : '—',
          icon: 'AlertTriangleIcon',
          variant: 'warning',
        },
        {
          title: 'Отменено',
          value: s.cancelled_created != null ? s.cancelled_created : '—',
          icon: 'XCircleIcon',
          variant: 'danger',
        },
        {
          title: 'Не создано в ПФ',
          value: s.not_created != null ? s.not_created : '—',
          icon: 'SlashIcon',
          variant: 'secondary',
        },
        {
          title: 'Вне плана',
          value: s.off_plan != null ? s.off_plan : '—',
          icon: 'ExternalLinkIcon',
          variant: 'info',
        },
        {
          title: 'Конверсия',
          value: formatConversion(s.conversion),
          icon: 'PercentIcon',
          variant: 'primary',
        },
      ]
    })

    return { cards }
  },
}
</script>
